import { useEffect, useState } from "react";
import { toast } from "sonner";
import { PaperPlaneTilt } from "@phosphor-icons/react";
import api from "../../lib/api";
import { Button } from "../ui/button";

export default function AnnouncementTile() {
  const [status, setStatus] = useState(null);
  const [sending, setSending] = useState(false);
  const [confirming, setConfirming] = useState(false);

  const load = () =>
    api.get("/schedule-import/admin/announcement/status").then(({ data }) => setStatus(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const send = async () => {
    setSending(true);
    try {
      const { data } = await api.post("/schedule-import/admin/announcement/send");
      toast.success(`Sent to ${data.sent} owner${data.sent === 1 ? "" : "s"} (${data.skipped_already_sent} already had it).`);
      setConfirming(false);
      load();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Send failed.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="space-y-3" data-testid="magic-import-announcement-tile">
      <p className="text-sm text-muted-foreground">
        One-time email to every owner announcing Magic Schedule Import (paste text / photo → AI drafts
        the week; 3 free per month, unlimited for Pro). Idempotent — each owner only ever gets it once,
        and unsubscribed addresses are skipped automatically.
      </p>
      {status && (
        <p className="text-xs text-muted-foreground" data-testid="announcement-status">
          {status.sent} of {status.owners} owners emailed so far.
        </p>
      )}
      {!confirming ? (
        <Button onClick={() => setConfirming(true)} data-testid="announce-magic-import-btn">
          <PaperPlaneTilt className="h-4 w-4 mr-1.5" /> Send announcement…
        </Button>
      ) : (
        <div className="flex items-center gap-2">
          <Button onClick={send} disabled={sending} data-testid="announce-confirm-btn">
            {sending ? "Sending…" : `Yes, email ${status ? status.owners - status.sent : "all"} owners`}
          </Button>
          <Button variant="outline" onClick={() => setConfirming(false)} data-testid="announce-cancel-btn">
            Cancel
          </Button>
        </div>
      )}
    </div>
  );
}
